export const FIXED_VALUE_INDICATOR = '--FixedValue--';
